export type TitleInlineIcon = "gift" | "subscription";

/**
 * Picks the icon shown inline before a content card's title. Gifted content
 * (unlocked by a partnership or redemption) replaces the premium icon, so the
 * two never render together.
 */
export const getTitleInlineIcon = ({
  gift,
  subscription,
}: {
  gift?: boolean;
  subscription?: boolean;
}): TitleInlineIcon | null => {
  if (gift) return "gift";
  if (subscription) return "subscription";
  return null;
};
